import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { get, post } from "./common/http";
import { API_ENDPOINTS } from "./Utils/endpoints";


export const UserGroupMenuAccess = (param:any) =>
    GET_ENC(API_ENDPOINTS.USER_GROUP_ACCESS.GET_USER_GROUP_MENU_ACCESS + param,null);

export const GetUserGroupList = (param:any) =>
    GET_ENC(API_ENDPOINTS.USER_GROUP_ACCESS.GET_USER_GROUP_LIST + param,null);

export const GetMenuAccess = (param:any) =>
    GET_ENC(API_ENDPOINTS.USER_GROUP_ACCESS.GET_MENU_ACCESS + param,null)

export const saveUserMenuAccessData = (data: any) =>
    POST_ENC(API_ENDPOINTS.USER_GROUP_ACCESS.CREATE, data, true);